//
//
//
//
//
//
//
//
//
//

import { subscribeToQuery } from 'datocms-listen'
import createQuery from '~/gql/collection.gql'

export default {
  async asyncData ({ $contentAPI, error, $sentry, route, query, store }) {
    const preview = process.client && query.preview
    const slug = route.path.match(/\/shop\/([A-z]+)/)[1]
    const gqlQuery = createQuery(slug)
    const result = await $contentAPI.fetch({ query: gqlQuery, preview })
    if (!result || !result.collection || result.errors) {
      const errorsToLog = result.errors || 'Error fetching page'
      $sentry.captureException(errorsToLog)
      error({ statusCode: 404, message: 'Unable to load page' })
    }
    return { ...result.collection, query: gqlQuery }
  },
  async fetch () {
    await this.$store.dispatch('insta/GET_FOR_PRODUCTS', this.products)
  },
  head () {
    return this.$head(this.meta)
  },
  computed: {
    pageMode () {
      return {
        s: 'sunglasses',
        e: 'goggles',
        p: 'pace'
      }[this.pageData.content.replace(/<[^>]*>/g, '').slice(-1)] || 'sunglasses'
    },
    products () {
      if (this.pageMode === 'goggles') {
        return ['vanguards', 'snipers']
      } else if (this.pageMode === 'pace') {
        return ['vulcans-tf', 'velans-tf', 'vulcans-ff', 'velans-ff', 'airas-zf', 'airas-bf']
      }
      return ['classics3', 'renegades', 'sierras']
    }
  },
  async mounted () {
    if (this.$route.query.preview) {
      this.unsubscribe = await subscribeToQuery({
        token: this.$config.datoApiToken,
        query: this.query,
        preview: true,
        onChannelError: this.onChannelError,
        onUpdate: this.onUpdate
      })
    }
  },
  methods: {
    unsubscribe () {},
    onChannelError (error) {
      console.error(error)
    },
    onUpdate (update) {
      this.rows = update.response.data.collection.rows
    }
  }
}
